<app-context-menu-item
  title="Create event"
  [close]="true"
  (execute)="createEvent()"
  />

  @if (calendarType !== CalendarType.DAY) {
    <app-context-menu-item
      title="Open day"
      [close]="true"
      (execute)="openCalendar(CalendarType.DAY)"
      />
  }

  @if (calendarType !== CalendarType.WEEK) {
    <app-context-menu-item
      title="Open week"
      [close]="true"
      (execute)="openCalendar(CalendarType.WEEK)"
      />
  }

  @if (calendarType !== CalendarType.MONTH) {
    <app-context-menu-item
      title="Open month"
      [close]="true"
      (execute)="openCalendar(CalendarType.MONTH)"
      />
  }

  @if (calendarType !== CalendarType.YEAR) {
    <app-context-menu-item
      title="Open year"
      [close]="true"
      (execute)="openCalendar(CalendarType.YEAR)"
      />
  }
